import {Box, Button, Group, Modal} from '@mantine/core';
import React from 'react';

import {useFilePreviewModalStyles} from 'files/preview/useFilePreviewModalStyles';
import {CenteredSpinner} from 'ui-library/Spinner';

import {openScratchFileInNewTab} from './ScratchFileChip';
import {renderFilePreview} from './ScratchFilePaneContent';
import {ScratchFileContent} from './ScratchFileTypes';

interface ScratchFilePreviewModalProps {
  scratchFile: ScratchFileContent | null;
  opened: boolean;
  onClose: () => void;
  extraActions?: React.ReactNode;
}

/** Full-size preview of a scratch file, mounting the preview only while the modal is open. */
export default function ScratchFilePreviewModal({
  scratchFile,
  opened,
  onClose,
  extraActions,
}: ScratchFilePreviewModalProps): JSX.Element {
  const {classes} = useFilePreviewModalStyles();
  const canDownload = scratchFile?.externalFileId != null && scratchFile.downloadUrl != null;

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={scratchFile?.filename ?? 'File preview'}
      closeButtonProps={{'aria-label': 'Close modal'}}
      size="min(1200px, 95vw)"
      centered={true}
      withinPortal={true}
      classNames={{inner: classes.inner, content: classes.content, body: classes.body}}
    >
      {scratchFile == null ? (
        <CenteredSpinner />
      ) : (
        <>
          <Box className={classes.preview}>{opened && renderFilePreview(scratchFile)}</Box>
          {(canDownload || extraActions != null) && (
            <Group position="right" mt="lg">
              {extraActions}
              {canDownload && (
                <Button variant="primary" onClick={() => openScratchFileInNewTab(scratchFile)}>
                  Download
                </Button>
              )}
            </Group>
          )}
        </>
      )}
    </Modal>
  );
}
